import { Box, InputAdornment, Switch, TextField, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { CustomSkillIndicator } from "../skill-mappings/custom-skill-indicator"

export function SkillOverrideRow({ item, overrides, symbol, onChange, readOnly }) {
    const existing = (overrides || []).find(matchesSkill)
    const isOverride = !!existing
    const rateValue = existing?.hourlyRate ?? ""
    const fieldValue = getFieldValue()

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ flex: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography variant="body2">{item.skillName || item.skillId}</Typography>
                    <If value={item.isCustomSkill}>
                        <CustomSkillIndicator rate={item.customHourlyRate} />
                    </If>
                </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="caption" color="text.secondary">
                    Inherit
                </Typography>
                <Switch
                    size="small"
                    checked={isOverride}
                    onChange={handleToggle}
                    disabled={readOnly}
                    data-cy={`skill-override-toggle-${item.skillId}`}
                />
                <Typography variant="caption" color="text.secondary">
                    Override
                </Typography>
            </Box>
            <Box sx={{ width: 140 }}>
                <TextField
                    size="small"
                    value={fieldValue}
                    disabled={!isOverride || readOnly}
                    onChange={(e) => handleRateChange(e.target.value)}
                    placeholder="0.00"
                    inputProps={{ inputMode: "decimal" }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">{symbol}</InputAdornment>,
                    }}
                    sx={{ "& input": { textAlign: "right", py: 0.75 } }}
                    fullWidth
                    data-cy={`skill-override-rate-${item.skillId}`}
                />
            </Box>
        </Box>
    )

    function matchesSkill(o) {
        return String(o.skillId) === String(item.skillId)
    }

    function handleRateChange(raw) {
        if (readOnly) return
        const numeric = parseFloat(String(raw).replace(/,/g, ""))
        if (!Number.isFinite(numeric) || numeric < 0) {
            return
        }
        onChange(item.skillId, numeric)
    }

    function handleToggle(e) {
        if (readOnly) return
        const nextRate = e.target.checked ? rateValue || 0 : null
        onChange(item.skillId, nextRate)
    }

    function getFieldValue() {
        if (isOverride) return rateValue
        return ""
    }
}
